export default __webpack_public_path__ + "media/color/btg-0b16b1a2.svg";